import type {Routes} from '@angular/router';

import {afterAuthRootRedirect, authGuard} from './auth/auth.guard';

export const ROUTES: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./auth/auth.component').then(m => m.AuthComponent),
  },
  {
    path: '',
    loadComponent: () => import('./main-wrapper/main-wrapper.component').then(m => m.MainWrapperComponent),
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: afterAuthRootRedirect,
        pathMatch: 'full',
      },
      {
        path: 'billings',
        loadComponent: () => import('./billings/billings-page.component').then(m => m.BillingsPageComponent),
      },
      {
        path: 'rounds',
        loadComponent: () => import('./rounds/rounds.component').then(m => m.RoundsComponent),
      },
      {
        path: 'games',
        loadComponent: () => import('./games/games.component').then(m => m.GamesComponent),
      },
      {
        path: 'games/sites/:site',
        loadComponent: () => import('./games/games.component').then(m => m.GamesComponent),
      },
      {
        path: 'users',
        loadComponent: () => import('./users/users.component').then(m => m.UsersComponent),
      },
      {
        path: 'games-performance',
        loadComponent: () =>
          import('./games-performance/games-performance.component').then(m => m.GamesPerformanceComponent),
      },
      {
        path: 'rng',
        loadComponent: () => import('./rng/rng.component').then(m => m.RngComponent),
      },
    ],
  },
];
